import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';
import { forgotPasswordInput } from '@barbeiropro/contracts';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Field } from '@/components/shared/field';
import { api, errorMessage } from '@/lib/api';
import { AuthLayout } from './auth-layout';
import { FormError } from './form-error';

export function ForgotPasswordPage() {
  const [done, setDone] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const form = useForm<{ email: string }>({ resolver: zodResolver(forgotPasswordInput) });
  const onSubmit = form.handleSubmit(async (v) => {
    setError(null);
    try {
      const r = await api.post<{ message: string }>('/auth/forgot-password', v);
      setDone(r.message);
    } catch (e) {
      setError(errorMessage(e));
    }
  });
  return (
    <AuthLayout title="Recuperar senha" subtitle="Enviamos um link para criar uma nova senha." footer={<Link to="/entrar" className="underline-offset-4 hover:underline">Voltar para entrar</Link>}>
      {done ? (
        <p role="status" className="rounded-md border bg-card px-4 py-3 text-sm">{done}</p>
      ) : (
        <form onSubmit={onSubmit} className="grid gap-4" noValidate>
          <FormError message={error} />
          <Field id="email" label="E-mail" error={form.formState.errors.email?.message}>
            <Input id="email" type="email" autoComplete="email" {...form.register('email')} />
          </Field>
          <Button type="submit" size="lg" disabled={form.formState.isSubmitting}>
            Enviar link
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
